<form [formGroup]="form" class="form-horizontal" autocomplete="off" novalidate>
  <app-translation-options
    [defaultLanguage]="defaultLanguage"
    [additionalLanguages]="additionalLanguages"
    (openedTranslation)="onOpenedTranslation($event)"
    *ngIf="!createMode && additionalLanguages.length > 0"
  ></app-translation-options>

  <!-- Name -->
  <div class="form-group">
    <label class="col-md-4 control-label">
      <span class="required" [hidden]="viewMode">*</span> {{ 'NAME' | translate }}
    </label>
    <div class="col-md-8">
      <div [hidden]="!viewMode" class="form-label">
        {{ occupancyType.name }}
      </div>
      <div [hidden]="viewMode">
        <input type="text" class="form-control" formControlName="name" maxlength="100" />
        <app-form-errors
          [control]="form.controls['name']"
          [formSubmited]="formSubmited"
        ></app-form-errors>
        <app-form-server-errors [error]="serverErrors['name']"></app-form-server-errors>
      </div>
    </div>
  </div>

  <!-- Occupancy -->
  <div class="form-group">
    <label class="col-md-4 control-label">
      <span class="required" [hidden]="viewMode">*</span> {{ 'OCCUPANCY' | translate }}
    </label>
    <div class="col-md-8">
      <div [hidden]="!viewMode" class="form-label">
        {{ occupancyType.occupancy }}
      </div>
      <div [hidden]="viewMode">
        <input
          type="number"
          class="form-control"
          formControlName="occupancy"
          min="1"
          [appInputNumberMaxLength]="3"
        />
        <app-form-errors
          [control]="form.controls['occupancy']"
          [formSubmited]="formSubmited"
        ></app-form-errors>
        <app-form-server-errors [error]="serverErrors['occupancy']"></app-form-server-errors>
      </div>
    </div>
  </div>

  <div class="form-actions no-wrap">
    <app-item-detail-form-actions
      [createMode]="createMode"
      [disableSaveItem]="sendingForm"
      [isModal]="isModal"
      [sendingForm]="sendingForm"
      [viewMode]="viewMode"
      (canceled)="onCanceled()"
      (edited)="onEditedOccupancyType()"
      (saved)="onSavedOccupancyType()"
    >
    </app-item-detail-form-actions>
  </div>
</form>
